import { useQuery } from "react-query";

import * as bankingInformationService from "api/services/bankingInformationService";
import * as reviewService from "api/services/reviewsService";
import { bankInformationStatuses } from "constants/amoTableDropdownOptions";
import { removeTime } from "utils/date";

/**
 * Store server's state of banking information reviews
 *
 * @returns The query object returned by the useQuery hook
 */
export const useBankingInformationReviewsHooks = () =>
  useQuery(
    ["bankingInformationReviews"],
    () => reviewService.getBankingInformationReviews(),
    {
      select: ({ data }) =>
        data?.map((item) => {
          let isExported;

          if (
            ![
              bankInformationStatuses.Verified,
              bankInformationStatuses.Changed,
            ].includes(item.status)
          ) {
            isExported = "N/A";
          } else if (item.isExportedAfterUpdate) {
            isExported = "Yes";
          } else {
            isExported = "No";
          }

          return {
            ...item,
            updatedDate: removeTime(item.updatedDate),
            isExported,
          };
        }) ?? [],
    }
  );

/**
 * Store server's state of the last banking information verification request
 *
 * @returns The query object returned by the useQuery hook
 */
export const useVerificationRequestHooks = () =>
  useQuery(
    ["verificationRequest"],
    () => bankingInformationService.getRequestVerification(),
    {
      select: ({ data }) => data,
    }
  );

/**
 * Store server's state of banking information reviews
 *
 * @returns The query object returned by the useQuery hook
 */
export const useBankingInformationPlaceholdersHooks = () =>
  useQuery(
    ["bankingInformationPlaceholders"],
    () => reviewService.getBankingInformationPlaceholders(),
    {
      select: ({ data }) => data,
    }
  );
